import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  exports: [MatTooltipModule],
})
export class SnTooltipModule {}
